export enum PlayerAnimationRefs {
  board = 'board',
  summary = 'summary',
  favor = 'favor',
  gold = 'gold',
  military = 'military',
}

export type AnimationRefSetter = (
  playerID: string,
  refType: PlayerAnimationRefs,
  ref: HTMLDivElement | null,
) => void;
